/* @flow */
import React from "react";
import cn from "classnames";
import type { Card } from "@raise/with-cart-context-provider";

import s from "./styles.scss";
import { toMoney } from "../Util";

type ListItemProps = {
  card: Card,
  removeCard: Card => void
};

const ListItem = ({ card, removeCard }: ListItemProps) => {
  const {
    cardUrl,
    cardType,
    imageAlt,
    imageSrc,
    name,
    uuid,
    value,
    price
  } = card;
  const cardTypes = (cardType && cardType.cardTypes) || [];

  return (
    <li className={s.item}>
      <a className={s.imageWrapper} href={cardUrl} rel="noopener noreferrer">
        <img
          className={s.image}
          draggable="false"
          alt={imageAlt}
          src={imageSrc}
        />
      </a>
      <div className={s.description}>
        <a className={s.cardName} href={cardUrl}>
          {name}
        </a>
        {cardTypes.map(c => (
          <span className={s.badge} key={c.content}>
            {c.content}
          </span>
        ))}
      </div>
      <div className={s.cardValue}>
      {value}{" "}
        <div className={s.mobileBlock}>
          <span className={s.for}>for</span>&nbsp;
          <span className={s.cardValue__blue}>{toMoney(price)}</span>
        </div>
      </div>
      <button
        data-testid="remove-cart-item-button"
        data-logid="remove-cart-item-cart-menu-button"
        data-gtm="true"
        data-payload={uuid}
        type="button"
        aria-label="Remove Card"
        onClick={() => removeCard(card)}
        className={s.remove}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          role="presentation"
          focusable="false"
          className={s.removeSvg}
          viewBox="0 0 40 40"
        >
          <path d="M 10,10 L 30,30 M 30,10 L 10,30" />
        </svg>
      </button>
    </li>
  );
};

ListItem.defaultProps = {
  isMobile: true,
  removeCard: () => {}
};

export default ListItem;
